import { render, staticRenderFns } from "./EmpServiceBookDashboard.vue?vue&type=template&id=123aded4&scoped=true"
import script from "./EmpServiceBookDashboard.vue?vue&type=script&lang=js"
export * from "./EmpServiceBookDashboard.vue?vue&type=script&lang=js"
import style0 from "./EmpServiceBookDashboard.vue?vue&type=style&index=0&id=123aded4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123aded4",
  null
  
)

export default component.exports